import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e18ebec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'test',
  setup(__props) {

const payUrl = ref('')

function jump() {
  location.href = payUrl.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payUrl).value = $event))
      }, null, 512), [
        [_vModelText, payUrl.value]
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("button", { onClick: jump }, "跳转")
    ])
  ]))
}
}

})